<script setup>
import { inject } from "vue";
import { useI18n } from "vue-i18n";

import QButton from "@/components/ui/QButton.vue";
import QModal from "@/components/ui/QModal.vue";

const { t } = useI18n();

const props = defineProps({
    feedbackLayout: {
        type: Object,
        default: () => {},
    },
});

const state = inject("state");

const handleSuccessFormClose = () => {
    state.showModal = false;
    state.successForm = false;
};
</script>

<template lang="pug">
QModal.qmodii-feedback-modal-success(
    v-if="feedbackLayout.successForm",
    :visible="state.showModal && state.successForm",
    @update:visible="handleSuccessFormClose",
    transition="fade"
)
    template(#default)
        img.qmodii-feedback-success-logo.qmodii-text-center(
            v-if="feedbackLayout.successForm.logoURL",
            :src="feedbackLayout.successForm.logoURL",
            alt="Success Logo",
            rel="preload"
        )
        h2.qmodii-heading.qmodii-text-center(v-if="feedbackLayout.successForm.heading") {{ feedbackLayout.successForm.heading }}
        p.qmodii-text.qmodii-text-center(v-if="feedbackLayout.successForm.body") {{ feedbackLayout.successForm.body }}
    template(#footer)
        QButton.qmodii-button-close(
            type="button",
            theme="secondary",
            @click="handleSuccessFormClose"
        ) {{ t("Close") }}
</template>

<style lang="stylus">
.qmodii-feedback-modal-success
    img.qmodii-feedback-success-logo
        width 50%
        margin auto
</style>
